import React from 'react';
import PropTypes from 'prop-types';
import { EntryAnchorStyled as EntryAnchor } from './styles/CustomEntriesStyled';

const GoToWom = ({ baseComponent: EntryComponent, children, ...props }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <EntryComponent {...props} mobileOnly>
    <EntryAnchor href="https://www.wom.cl/" target="blank">
      {children}
    </EntryAnchor>
  </EntryComponent>
);

GoToWom.propTypes = {
  baseComponent: PropTypes.elementType.isRequired,
  children: PropTypes.node.isRequired,
};

export default GoToWom;
